<div class='FranchiseeControl'>
  <ng-container *ngIf='canAttribute'>
    <div *ngIf='getFranchiseeLabel()' class='FranchiseeControl__label'>{{ getFranchiseeLabel() }}</div>
    <div class='d-flex flex-row align-items-center justify-content-center'>
      <app-button
        [Click]='attributeButtonProperties.onClick'
        [color]='attributeButtonProperties.color'
        [disabled]='isInherited'
        [size]='attributeButtonProperties.size'
        [style]='attributeButtonProperties.style'
        [text]='attributeButtonProperties.text'></app-button>
      <mat-icon (click)='resetFranchisee()' *ngIf='column.franchisee_id && canChangeFranchisee'>close</mat-icon>
    </div>
  </ng-container>
  <div
    *ngIf="column.account_role === 'franchisee'"
    class='d-flex flex-row align-items-center justify-content-center'>
    <app-button
      [Click]='viewRepButtonProperties.onClick'
      [color]='viewRepButtonProperties.color'
      [size]='viewRepButtonProperties.size'
      [style]='viewRepButtonProperties.style'
      [text]='viewRepButtonProperties.text'
      class='mt-2'></app-button>
  </div>
</div>
